'use strict';

const {degToRad} = require('../utils/misc');
const DrawingElement = require('../classes/DrawingElement');
const Shape = require('../classes/Shape');
const Point = require('../classes/Point');

module.exports = new DrawingElement('carpet', function () {
    let sideLength = this.width - this.pad * 2;

    let shape = new Shape.Quadrilateral.Square(new Point(this.pad + sideLength, this.pad + sideLength), sideLength);
    shape.dotSize = 0.5;
    shape.dumbSquare = true;

    shape.carpet(this.ctx, 5);
});


